import { Injectable } from '@angular/core';
import { RequestOptions, Headers, Http } from '@angular/http';
import { AlertController, LoadingController, ModalController, ToastController } from 'ionic-angular';
import { DevicesProvider } from '../devices/devices';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PrintProvider } from '../print/print';
import EscPosEncoder from 'esc-pos-encoder-ionic';
import { Storage } from '@ionic/storage';

const encoder = new EscPosEncoder();


@Injectable()
export class NfceProvider {

  imgNFCe = new Image();
  impressora = "";

  constructor(
    public http: Http,
    public httpClient: HttpClient,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private devicesProvider: DevicesProvider,
    private storage: Storage,
    private printProvider: PrintProvider) {
    this.devicesProvider.verificarConexaoInternet();
    let teste = this.carregarImpressoraPadrao();
  }

  async carregarImpressoraPadrao() {
    return this.storage.get('impressora').then(async (val) => {
      this.impressora = val;
      return this.impressora;
    });
  }

  abreToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 2000
    });

    toast.present();
  }

  enviarRequisicaoPost(endpoint, json, msg, isJson: boolean = true) {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Content-Type', 'application/json; charset=utf-8');

      let url = this.devicesProvider.getURLNFCe();
      if (endpoint) {
        url = url + '/' + endpoint
      }

      if (this.devicesProvider.conexao) {
        let loading = this.loadingCtrl.create({
          content: msg
        });
        loading.present();

        if (isJson) {
          this.httpClient.post(url, json, { headers })
            .subscribe(data => {
              loading.dismiss();
              resolve(data);
            });

        } else {
          this.httpClient.post(url, json, { headers: headers, responseType: 'text' })
            .subscribe(data => {
              loading.dismiss();
              console.log(data);
              resolve(data);
            });

        }
      } else {
        this.abreToast('Não é possível se comunicação com o servidor, sem conexão com a internet..');
        resolve(false);
      }
    });
  }

  enviarRequisicaoGet(endpoint, msg) {
    return new Promise((resolve, reject) => {
      let url = this.devicesProvider.getURLNFCe();
      if (endpoint) {
        url = url + '/' + endpoint
      }

      if (this.devicesProvider.conexao) {

        let loading = this.loadingCtrl.create({
          content: msg
        });
        loading.present();

        this.http.get(url)
          .map(res => res.json())
          .subscribe(data => {
            loading.dismiss();
            resolve(data);
          });
      } else {
        this.abreToast('Não é possível se comunicação com o servidor, sem conexão com a internet..');
        resolve(false);
      }
    });
  }

  testaCPF(cpf) {
    var Soma = 0;
    // Verifica se a variável cpf é igual a "undefined", exibindo uma msg de erro
    if (cpf === undefined) {
      return false;
    }

    // Esta função retira os caracteres . e - da string do cpf, deixando apenas os números
    var strCPF = cpf.replace('.', '').replace('.', '').replace('-', '');
    // Testa as sequencias que possuem todos os dígitos iguais e, se o cpf não tem 11 dígitos, retorna falso e exibe uma msg de erro
    if (strCPF === '00000000000' || strCPF === '11111111111' || strCPF === '22222222222' || strCPF === '33333333333' ||
      strCPF === '44444444444' || strCPF === '55555555555' || strCPF === '66666666666' || strCPF === '77777777777' || strCPF === '88888888888' ||
      strCPF === '99999999999' || strCPF.length !== 11) {
      return false;
    }

    // Os seis blocos seguintes de funções vão realizar a validação do CPF propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número para ser testado

    //Multiplica cada digito por numeros de 1 a 9, soma-os e multiplica-os por 10. Depois, divide o resultado encontrado por 11 para encontrar o resto
    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }

    var Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      return false;
    }

    Soma = 0;
    for (let k = 1; k <= 10; k++) {
      Soma = Soma + parseInt(strCPF.substring(k - 1, k)) * (12 - k)
    }

    Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }

    if (Resto !== parseInt(strCPF.substring(10, 11))) {
      return false;
    }

    return true;
  }

  testaCNPJ(cnpj) {
    // Verifica se a variável cnpj é igua a "undefined", exibindo uma msg de erro
    if (cnpj === undefined) {
      return false;
    }

    // Esta função retira os caracteres . / - da string do cnpj, deixando apenas os números
    var strCNPJ = cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

    // Testa as sequencias que possuem todos os dígitos iguais e se o cnpj não tem 14 dígitos, retonando falso e exibindo uma msg de erro
    if (strCNPJ === '00000000000000' || strCNPJ === '11111111111111' || strCNPJ === '22222222222222' || strCNPJ === '33333333333333' ||
      strCNPJ === '44444444444444' || strCNPJ === '55555555555555' || strCNPJ === '66666666666666' || strCNPJ === '77777777777777' ||
      strCNPJ === '88888888888888' || strCNPJ === '99999999999999' || strCNPJ.length !== 14) {
      return false;
    }

    // A variável numeros pega o bloco com os números sem o DV, a variavel digitos pega apenas os dois ultimos numeros (Digito Verificador).
    var tamanho = strCNPJ.length - 2;
    var numeros = strCNPJ.substring(0, tamanho);
    var digitos = strCNPJ.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    // Os quatro blocos seguintes de funções irá reaizar a validação do CNPJ propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = strCNPJ.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let k = tamanho; k >= 1; k--) {
      soma += numeros.charAt(tamanho - k) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  gerarNFCe(codVenda, modeloVenda, telefone) {
    return new Promise((resolve, reject) => {
      let json = {
        bd: this.devicesProvider.databaseName,
        numFilial: this.devicesProvider.getCodFilial(),
        codVenda: codVenda,
        modeloVenda: modeloVenda,
        uuid: this.devicesProvider.device.uuid,
        cpfCnpj: ''
      }

      let confirm = this.alertCtrl.create({
        title: 'Atec Delivery',
        message: 'CPF/CNPJ no cupom',
        inputs: [
          {
            name: 'cpf',
            placeholder: 'CPF/CNPJ',
            type: 'tel'
          }
        ],
        buttons: [
          {
            text: 'Ok',
            handler: (data) => {

              if ((data.cpf) && (data.cpf != "")) {
                if ((this.testaCPF(data.cpf)) || (this.testaCNPJ(data.cpf))) {
                  json.cpfCnpj = data.cpf;
                } else {
                  const alert = this.alertCtrl.create({
                    title: 'CPF/CNPJ Inválido!',
                    message: 'Digite um número de CPF/CNPJ válido para prosseguir',
                    buttons: ['OK']
                  });
                  alert.present();

                  return false;
                }
              }

              this.enviarRequisicaoPost('', json, 'Gerando NFC-e, aguarde...', false).then((result: any) => {
                console.log(result);
                if (result) {
                  let confirm = this.alertCtrl.create({
                    title: 'Atec Delivery',
                    message: 'NFC-e gerada com sucesso. Deseja compartilhar o cupom?',
                    buttons: [
                      {
                        text: 'Sim',
                        handler: () => {
                          let compartilharModal = this.modalCtrl.create('CompartilharNfcePage');
                          compartilharModal.present();

                          compartilharModal.onDidDismiss(data => {
                            this.compartilharNFCe(data.option, result, telefone, data.email);
                            resolve(result);
                          });
                        }
                      },
                      {
                        text: 'Não',
                        handler: () => {
                          resolve(result);
                        }
                      }
                    ]
                  });
                  confirm.present();
                }
              });
            }
          }
        ]
      });
      confirm.present();
    });
  }

  compartilharNFCe(option, codNFCe, telefone, email = '') {
    switch (option) {
      case 0: {
        this.enviarSMS(codNFCe, telefone);
        break;
      }
      case 1: {
        this.enviarWhatsApp(codNFCe, telefone);
        break;
      }
      case 2: {
        this.enviarEmail(codNFCe, email);
        break;
      }
    }

  }

  enviarSMS(codNFCe, telefone) {
    let json = {
      bd: this.devicesProvider.databaseName,
      numFilial: this.devicesProvider.getCodFilial(),
      id: codNFCe
    }

    this.enviarRequisicaoPost('dados', json, 'Recebendo dados da NFC-e, aguarde...', true).then((result: any) => {
      if (result) {
        let texto = this.devicesProvider.dadosDevice.Emp_NomeFantasia + ' informa: ' +
          'Prezado cliente, você está recebendo o link para consulta da sua NFC-e nº ' + result.numero + ' abaixo: ' +
          result.linkConsulta;

        let url = 'sms:' + telefone + '?body=' + encodeURI(texto);
        window.open(url);
      }
    });
  }

  enviarWhatsApp(codNFCe, telefone) {
    let json = {
      bd: this.devicesProvider.databaseName,
      numFilial: this.devicesProvider.getCodFilial(),
      id: codNFCe
    }

    this.enviarRequisicaoPost('dados', json, 'Recebendo dados da NFC-e, aguarde...', true).then((result: any) => {
      if (result) {
        let texto = this.devicesProvider.dadosDevice.Emp_NomeFantasia + ' informa: \n\n' +
          'Prezado cliente, \nVocê está recebendo o link para consulta de autenticidade da sua NFC-e nº ' + result.numero + ' abaixo: \n\n' +
          result.linkConsulta + '\n\nPara visualizar e baixar o seu cupom fiscal em PDF, clique no próximo link abaixo: \n\n' +
          this.devicesProvider.getURLNFCe() + '/imprimir/' + json.bd + '/' + json.numFilial + '/' + json.id;

        let url = 'https://api.whatsapp.com/send?phone=55' + telefone + '&text=' + encodeURI(texto);
        window.open(url);
      }
    });
  }

  enviarEmail(codNFCe, email) {
    let json = {
      bd: this.devicesProvider.databaseName,
      numFilial: this.devicesProvider.getCodFilial(),
      id: codNFCe,
      email: email
    }

    this.enviarRequisicaoPost('email', json, 'Enviando e-mail, aguarde...', false).then((result: any) => {
      if (result) {
        console.log(result);
        alert(result);
      }
    });
  }

  carregaImagemNFCe(img) {
    return new Promise((resolve, reject) => {
      this.imgNFCe.src = 'data:image/bmp;base64,' + img;
      this.imgNFCe.onload = function () {
        resolve(true);
      }
    })
  }

  imprimir(codNFCe) {
    let json = {
      bd: this.devicesProvider.databaseName,
      numFilial: this.devicesProvider.getCodFilial(),
      id: codNFCe
    }

    this.enviarRequisicaoPost('imprimirBase64', json, 'Solicitado impressão da nfc-e, aguarde...', false).then((result: any) => {
      if (result) {
        let boleto = null;
        this.carregaImagemNFCe(result.imgNFCe).then(() => {
          boleto = encoder.initialize()
            .image(this.imgNFCe, 640, 2120, 'atkinson')
            .newline()
            .newline()
            .encode();

          this.printProvider.sendToBluetoothPrinter(this.impressora, boleto);
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/nfce/nfce.ts